import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { baseUrl } from 'constant'
import { RootState } from 'store/store'
import { getAuthToken } from 'utils/getAuthToken'
import { handlingErrorResponse } from 'utils/HandlingErrorResponse'
import { employeeRoleByIdUrl } from './const'
import {
    IEmployeeRoleByIdRespones,
    IEmployeeRoleByIdType,
} from './type'

export const getEmployeeRoleByIdApi = createApi({
    reducerPath: 'getEmployeeRoleByIdApi',
    baseQuery: fetchBaseQuery({
        baseUrl: baseUrl,
        prepareHeaders: (headers, { getState }) => {
            const token = getAuthToken(getState() as RootState)
            if (token) {
                headers.set('Authorization', `Bearer ${token}`)
            }
            return headers
        },
    }),
    tagTypes: ['GetEmployeeRoleById'],
    endpoints: (builder) => ({
        GetEmployeeRoleByIdUrl: builder.query<IEmployeeRoleByIdRespones, IEmployeeRoleByIdType>({
            query: (params) => employeeRoleByIdUrl(params),
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'GetEmployeeRoleById', id: ' GetEmployeeRoleById' }]
        }),
    }),
})